/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Visa_Eb5_Extra_HeadingInputs */

const en_visa_eb5_extra_heading = /** @type {(inputs: Visa_Eb5_Extra_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Typical EB-5 Workflow`)
};

const pt_visa_eb5_extra_heading = /** @type {(inputs: Visa_Eb5_Extra_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fluxo de Trabalho Típico do EB-5`)
};

const es_visa_eb5_extra_heading = /** @type {(inputs: Visa_Eb5_Extra_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Flujo de Trabajo Típico del EB-5`)
};

/**
* | output |
* | --- |
* | "Typical EB-5 Workflow" |
*
* @param {Visa_Eb5_Extra_HeadingInputs} inputs
* @param {{ locale?: "en" | "pt" | "es" }} options
* @returns {LocalizedString}
*/
export const visa_eb5_extra_heading = /** @type {((inputs?: Visa_Eb5_Extra_HeadingInputs, options?: { locale?: "en" | "pt" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Visa_Eb5_Extra_HeadingInputs, { locale?: "en" | "pt" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt") return pt_visa_eb5_extra_heading(inputs)
	if (locale === "es") return es_visa_eb5_extra_heading(inputs)
	return en_visa_eb5_extra_heading(inputs)
});